import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-charcoal py-24 px-6 md:px-12" data-id="element-91">
      <div className="max-w-4xl mx-auto text-center" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-93">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-amber mb-10" data-id="element-94">
            La mayoría de las mujeres argentinas usan su AirFryer solo para
            calentar nuggets congelados...
          </h2>

          <p className="font-sans text-lg md:text-2xl text-cream/90 mb-8 leading-relaxed" data-id="element-95">
            ...porque los manuales que vienen en la caja están escritos para
            gente que no sabe qué es un buen rebozado.
          </p>

          <div className="bg-charcoal-light p-8 md:p-12 rounded-2xl shadow-xl mt-12" data-id="element-96">
            <p className="font-sans text-lg md:text-xl text-cream/90 leading-relaxed mb-6" data-id="element-97">
              Si intentaste cocinar comida de verdad y te quedó dura, chiclosa o
              sin gusto,{' '}
              <span className="text-amber font-bold text-xl md:text-2xl" data-id="element-98">
                no es tu culpa.
              </span>
            </p>
            <p className="font-sans text-lg md:text-xl text-cream/80 leading-relaxed" data-id="element-99">
              Es que nadie te explicó que la AirFryer no es un microondas, sino
              un motor de aire que, si no sabés dominarlo, le roba la humedad a
              tu cena.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}